/**
 * Workout entity – single lift log (exercise, weight, reps, optional video).
 */
export function createWorkout({
  id,
  userId,
  exercise,
  weight,
  reps,
  videoUrl = '',
  isPR = false,
  verified = false,
  verificationCount = 0,
  discipline = '', // user's discipline at post time (for feed filter)
  showInFeed = false, // at most one per user is shown in feed
  createdAt = null,
}) {
  return {
    id,
    userId,
    exercise,
    weight,
    reps,
    videoUrl,
    isPR,
    verified,
    verificationCount: verificationCount ?? 0,
    discipline: discipline || '',
    showInFeed: showInFeed === true,
    createdAt: createdAt?.toDate?.() ?? createdAt ?? null,
  };
}
